<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        v-if="hasAuthorizedMenus"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
      <div v-else class="sidebar-empty">
        <i class="el-icon-warning-outline sidebar-empty-icon" />
        <p class="sidebar-empty-title">暂无菜单权限</p>
        <p class="sidebar-empty-desc">请联系管理员为当前账号授权后刷新页面。</p>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo () {
      return this.$store.state.settings.sidebarLogo
    },
    variables () {
      return variables
    },
    isCollapse () {
      return !this.sidebar.opened
    },
    hasAuthorizedMenus () {
      if (!Array.isArray(this.permission_routes)) {
        return false
      }

      return this.permission_routes.some(route => this.hasVisibleMenu(route))
    }
  },
  methods: {
    hasVisibleMenu (route) {
      if (!route || route.hidden) {
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-empty {
  padding: 72px 16px 0;
  text-align: center;
  color: #b0b4bb;
}

.sidebar-empty-icon {
  font-size: 28px;
}

.sidebar-empty-title {
  margin: 12px 0 6px;
  font-size: 14px;
  color: #909399;
}

.sidebar-empty-desc {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}
</style>
